export default {
  path: '/avaliacoes-tecnicas',
  component: () => import('@/components/pages/ATServices/ATServices.vue')
}
